var cov_qli1gwa5o = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Switch/Switch.ts",
      hash = "5766f995e3fe5604567787e88136d8c032c53dd3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Switch/Switch.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import checkItem from '../Checkbox/CheckItem';
export default checkItem('switch');